import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <>
        <ToastContainer
            position="bottom-right"
            autoClose={2500}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme="light"
            transition={Slide}
            style={{ zIndex: 99999 }}
            toastStyle={{
                borderRadius: '4px',
                border: '1px solid #e5e7eb',
                boxShadow: 'none',
                fontSize: '13px',
                fontFamily:
                    "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                color: '#111827',
            }}
        />
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </>
);

reportWebVitals();
